import MediaSection from './media-section';

export default MediaSection;
export {MediaSection};